import type { AxiosError } from 'axios';

export const getSentryEnvironment = (hostname: string) => {
  if (hostname.includes('.staging.')) return 'staging';
  if (hostname.includes('.dev.')) return 'dev';
  return 'production';
};

// Ids, serials and emails in the path would give every request its own issue.
export const toEndpointTemplate = (url = '') =>
  url
    .split('?')[0]
    .split('/')
    .map((segment) => (/[\d@]/.test(segment) ? ':id' : segment))
    .join('/');

export const getApiErrorContext = (error: AxiosError) => {
  const method = error.config?.method?.toUpperCase() ?? 'GET';
  const endpoint = toEndpointTemplate(error.config?.url);
  const status = error.response?.status ?? 0;

  return {
    title: `${method} ${endpoint} failed with status ${status}`,
    fingerprint: ['api-error', method, endpoint, String(status)],
    tags: {
      'api.method': method,
      'api.endpoint': endpoint,
      'api.status': status,
    },
  };
};
